import {Domain} from 'shared';

export class MapSidebarFilter {
  domains: Domain[] = [];
  groupBy: 'none' | 'domain' | 'bu' | 'both' = 'domain';


  static fromJSON(raw: string): MapSidebarFilter {
    const inst = new MapSidebarFilter();
    Object.assign(inst, JSON.parse(raw));
    return inst;
  }

  active(): boolean {
    return this.domains.length > 0 || this.groupBy !== 'domain';
  }
}
